import React, { useState, useEffect, useRef } from 'react'
import {
  Card,
  CardBody,
  Row,
  Col,
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  CardHeader,
  CardTitle,
  Input,
  FormGroup,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Spinner,
} from "reactstrap"
import DateTime from 'react-datetime';
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import Loading from '../../../lib/loading'
import FormContas from './formContas'
import ReactSelect from 'components/Form/Select/Select'
import useForm from "../../../lib/useForm"
import moment from 'moment';
import Switch from 'react-switch';
import Swal from 'sweetalert2';
import DataTable from './DataTable';


const inicialForm = {
  loja: { id: '', title: 'TODAS AS LOJAS' },
  status: "T",
  emissao_pagamento: 'E',
  periodo: {
    dataI: '',
    dataF: ''
  }
}

function ContasApagar() {

  const colunas = [
    {
      datafield: 'id',
      text: 'Cód',
      align: 'center',
      hidden: false,
      width: '100px',
      visible: true
    }, {
      datafield: 'cedente',
      text: 'Fornecedor/Favorecido',
      align: 'left',
      visible: true,
      width: '130px',
      sort: true
    },
    {
      datafield: 'contas_pagar_id',
      text: 'ID',
      align: 'left',
      visible: false,
      width: '100px',
      align: 'center',
    },    
    {
      datafield: 'contpag_valor',
      text: 'Valor',
      align: 'center',
      headerStyle: { cursor: 'default' },
      width: '100px',
    },
    {
      datafield: 'contpag_emissao',
      text: 'Emissão',
      align: 'center',
      headerStyle: { cursor: 'default' },
      sort: true
    },
    {
      datafield: 'contpag_vencimento',
      text: 'Vencimento',
      align: 'center',
      headerStyle: { cursor: 'default' },
      sort: true
    },
    {
      datafield: 'contpag_datapag',
      text: 'Pagamento',
      align: 'center',
      headerStyle: { cursor: 'default' },
      sort: true
    },
    {
      datafield: 'contpag_num_doc',
      text: 'Documento',
      align: 'center',
      headerStyle: { cursor: 'default' },
    },
    {
      datafield: 'nota_fiscal',
      text: 'Nota Fiscal',
      align: 'center',
      headerStyle: { cursor: 'default' },
    },
    {
      datafield: 'fantasia',
      text: 'Fantasia',
      align: 'left',
      headerStyle: { cursor: 'default' }
    },
    {
      datafield: 'situacao',
      text: 'Situação',
      align: 'center',
      headerStyle: { cursor: 'default' }
    },
    {
      datafield: 'pagar',
      text: 'Pagar',
      align: 'center',
      switch: true,
      headerEvents: {
        onClick: (e, column, columnIndex) => setStateSwitch(!stateSwitch)
      },
      formatter: (cellContent, row) => {
        if (row.contpag_datapag == "") {
          return (
            <>

              <Switch
                id={row.id}
                className="react-switch"
                height={15}
                width={35}
                checked={row.pagar === 'S' ? true : false}
                onChange={(e) => { changeSwitch(row.id, e) }}
                onColor='#6bd098'
              />
            </>
          );
        } else {
          return (<></>)
        }


      },
      // editor: {
      //   type: Type.CHECKBOX,
      //   value: 'S:N'
      // },
      headerStyle: { cursor: 'pointer' },
      // editable:true
    }
  ]

  const [loading, setLoading] = useState(true)
  const [listaContas, setListaContas] = useState([])
  const [conta_id, setConta_id] = useState('')
  const [modal, setModal] = useState(false)
  const [countLista, setCountLista] = useState(0)
  const [listaLoja, setListaLoja] = useState([])
  const [form, onChange, setForm, onChangeSelect, onChangeDate, onChangeCustom, onChangeArray] = useForm(inicialForm)
  const [refresh, setRefresh] = useState(0);
  const [listaPlanoConta, setListaPlanoConta] = useState([])
  const [pageState, setPageState] = useState(1);
  const [stateSwitch, setStateSwitch] = useState(false);
  const [loadingPesquisa, setLoadingPesquisa] = useState(false);
  const [currentSort, setCurrentSort] = useState({ field: '', order: '' });
  const modalMontou = useRef(false);
    
  const changeSwitch = (id, value) => { 

    let frm = form;

    let lst = listaContas;

    let param = '';

    if (value === true) {
      param = 'S'
    } else {
      param = 'N'
    }

    lst.map(ls => {
      if (ls.id == id) {
        ls.pagar = param
      }
    })

    setListaContas(lst);
    setRefresh(refresh + 1);
    setForm(frm)
  }

  const changeSwitchAll = (value) => {

    const frm = JSON.parse(JSON.stringify(form));
    const lst = listaContas;

    let param = '';

    if (stateSwitch === true) {
      param = 'S'
    } else {
      param = 'N'
    }

    lst.map(ls => {
      if (ls.contpag_datapag == "") {
        ls.pagar = param
      }
    })

    setListaContas(lst);
    setRefresh(refresh + 1)
    setForm(frm)
  }

  const listaLojas = () => {
    let lista = [{ id: '', title: 'TODAS AS LOJAS' }]
    const url = rotas.lojas
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista !== '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].filial_id, "title": ret.lista[i].fantasia }
          }
          setListaLoja(lista)
        }
      })
      return (true)
    } catch (err) {
      console.log(err)
    }
  }

  const lista_contasPagar = (type = null, filtros = null) => {
    // setListaContas([])
    let lista = []
    let pagina = 1
    let order = currentSort.field ? currentSort.field + " " + currentSort.order : "";

    if (filtros) {
      pagina = filtros.page;
      setPageState(filtros.page)

      if (filtros.sortField) {
        order = filtros.sortField + " " + filtros.sortOrder;
        setCurrentSort({ field: filtros.sortField, order: filtros.sortOrder });
      }
    }

    if ((type === 'search') || (filtros !== null && filtros.searchText !== '')) {

      const pesquisa = filtros.searchText;

      if (pesquisa.length >= 3) {

        setLoadingPesquisa(true)

        if (type === 'search') {
          pagina = 1
          setPageState(1);
        }

        let parametros = {
          pesquisa: pesquisa,
          loja: form.loja.id,
          status: form.status,
          order: order
        }

        const url = rotas.contasApagar + pagina
        const retorno = rest.post(url, parametros)                
        retorno.then(ret => {          
          setLoadingPesquisa(false)          
          if (ret.success && ret.success == 'S' && ret.lista !== '') {            
            lista = ret.lista
            for (let i = 0; i < lista.length; i++) {
              lista[i]['contpag_valor'] = parseFloat(lista[i]['contpag_valor']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
              lista[i]['contpag_valor_antecipado'] = parseFloat(lista[i]['contpag_valor_antecipado']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
              lista[i]['contpag_valorpago'] = parseFloat(lista[i]['contpag_valorpago']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })

              if (lista[i]['contpag_datapag']) {
                lista[i]['situacao'] = <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Pago</span></div>
              } else {
                lista[i]['situacao'] = <div className="timeline-heading"><span className="badge badge-info badge-pill m-0 aberto">Aberto</span></div>
              }
              lista[i]['pagar'] = 'N'
            }            
            setListaContas(lista)

            if (pagina === 1) {
              setCountLista(ret.total)
            }
          }
        })
      }
      if (pesquisa.length < 3) {
        // setLoading(true)
        if (type === 'search') {
          pagina = 1
          setPageState(1);
        }

        let parametros = {
          loja: form.loja.id,
          status: form.status,
          order: order
        }

        const url = rotas.contasApagar + pagina
        try {                    
          const retorno = rest.post(url, parametros)
          retorno.then(ret => {
            if (ret.success && ret.success == 'S' && ret.lista != '') {
              lista = ret.lista

              for (let i = 0; i < lista.length; i++) {
                lista[i]['contpag_valor'] = parseFloat(lista[i]['contpag_valor']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                lista[i]['contpag_valor_antecipado'] = parseFloat(lista[i]['contpag_valor_antecipado']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                lista[i]['contpag_valorpago'] = parseFloat(lista[i]['contpag_valorpago']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })

                if (lista[i]['contpag_datapag']) {
                  lista[i]['situacao'] = <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Pago</span></div>
                } else {
                  lista[i]['situacao'] = <div className="timeline-heading"><span className="badge badge-info badge-pill m-0 aberto">Aberto</span></div>
                }
                lista[i]['pagar'] = 'N'
              }

              setListaContas(lista)

              if (pagina === 1) {
                setCountLista(ret.total)
              }
            }
            setLoading(false)            
          })
          return (true)
        } catch (err) {
          console.log(err)
        }
      }
      return true
    }

    let plano_contas_id = '';

    let listaPagar = [];

    if (form.planoContaSelect) {
      if (form.planoContaSelect.id !== '') {
        plano_contas_id = form.planoContaSelect.id;
      }
    }

    let parametros = {
      loja: form.loja.id,
      status: form.status,
      emissao_pagamento: form.emissao_pagamento,
      periodo: { dataI: form.periodo.dataI, dataF: form.periodo.dataF },
      plano_contas_id: plano_contas_id,
      order: order
    }

    

    const url = rotas.contasApagar + pagina

    try {
                  
      const retorno = rest.post(url, parametros)
      retorno.then(ret => {          
        if (ret.success && ret.success == 'S' && ret.lista != '') {
          lista = ret.lista
          for (let i = 0; i < lista.length; i++) {
            lista[i]['contpag_valor'] = parseFloat(lista[i]['contpag_valor']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            lista[i]['contpag_valor_antecipado'] = parseFloat(lista[i]['contpag_valor_antecipado']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            lista[i]['contpag_valorpago'] = parseFloat(lista[i]['contpag_valorpago']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })

            if (lista[i]['contpag_datapag']) {
              lista[i]['situacao'] = <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Pago</span></div>
            } else {
              lista[i]['situacao'] = <div className="timeline-heading"><span className="badge badge-info badge-pill m-0 aberto">Aberto</span></div>
            }
            lista[i]['pagar'] = 'N'
          }          
          setListaContas(lista);

          if (pagina === 1) {
            setCountLista(ret.total)
          }
        } else {
          
          setListaContas([])
        }        
        setLoading(false)
      })
      return (true)
    } catch (err) {
    }
  }

  const changeFiltros = (e) => {
    //  setLoading(true)

    if (typeof e.id !== 'undefined') {
      form.loja = e
    } else {
      form.status = e.target.value
    }


    lista_contasPagar()
  }

  const changePeriodo = (data, campo) => {
    if (data.length === 0) {
      if (campo === 'dataI') {
        form.periodo.dataI = '';
        setForm(form);
        setRefresh(refresh + 1)
      } else {
        form.periodo.dataF = '';
        setForm(form);
        setRefresh(refresh + 1)
      }
    } else if (!data.length) {
      if (campo === 'dataI') {
        form.periodo.dataI = moment(data).format('DD/MM/YYYY');
        setForm(form);
        setRefresh(refresh + 1)
      } else {
        form.periodo.dataF = moment(data).format('DD/MM/YYYY');
        setForm(form);
        setRefresh(refresh + 1)
      }
    } else {

      if (campo === 'dataI') {
        if (data.length === 2) {
          form.periodo.dataI = data + '/';
          setForm(form);
          setRefresh(refresh + 1)
        }
        if (data.length === 5) {
          form.periodo.dataI = data + '/';
          setForm(form);
          setRefresh(refresh + 1)
        }
      } else {
        if (data.length === 2) {
          form.periodo.dataF = data + '/';
          setForm(form);
          setRefresh(refresh + 1)
        }
        if (data.length === 5) {
          form.periodo.dataF = data + '/';
          setForm(form);
          setRefresh(refresh + 1)
        }
      }
    }
    //se as duas datas estiverem completas faz a pesquisa
    if ((form.periodo.dataI.length === 10) && (form.periodo.dataF.length === 10)) {
      lista_contasPagar();
    }
  }

  useEffect(() => {
    listaLojas()
    lista_contasPagar()
    listarPlanoContas();
  }, [])

  useEffect(() => {
    if (!modalMontou.current) {
      modalMontou.current = true
      return
    }
    if (modal === false) {
      lista_contasPagar(null, { page: pageState, searchText: "" })
    }
  }, [modal])

  useEffect(() => {
    changeSwitchAll(stateSwitch)
  }, [stateSwitch])

  // useEffect(()=>{
  //   lista_contasPagar()
  // },[form.planoContaSelect])

  // useEffect(()=>{
  //   lista_contasPagar();
  // },[form.emissao_pagamento])

  //abrir modal
  const abreModal = (id) => {    
    setConta_id(id)
    setModal(true)
  }

  const controlPaginacao = () => {
    let totalPaginas = Math.ceil(countLista / 10);

    let listaPaginas = [];

    let minPagina = 0;
    let maxPagina = 0;
    let paginaAtual = pageState;

    if (paginaAtual > 3) {
      minPagina = paginaAtual - 2;
      maxPagina = (paginaAtual + 2 <= totalPaginas) ? paginaAtual + 2 : totalPaginas;
    } else {
      minPagina = 1;
      maxPagina = 5;
    }

    for (let x = minPagina; x <= maxPagina; x++) {
      if (x > totalPaginas) {
        break;
      }
      listaPaginas.push(x);
    }

    return (
      listaPaginas.map((pagina, index) => (
        <PaginationItem key={index} active={pagina === pageState}>
          <PaginationLink onClick={() => lista_contasPagar(null, { page: pagina, searchText: "" })}>
            {pagina}
          </PaginationLink>
        </PaginationItem>
      ))
    )
  }

  const pagarEmMassa = () => {

    let dados = [];

    listaContas.map(lista => {
      if (lista.pagar === 'S') {
        dados.push(lista);
      }
    })

    const url = rotas.contasApagarEmMassa;

    const retorno = rest.post(url, dados);

    retorno.then(ret => {
      if (ret.success) {
        if (ret.success === "S") {
          Swal.fire("Sucesso",
            "Pagamentos enfetuados com sucesso!",
            'success');
        } else {
          Swal.fire("Atenção",
            "Não foi possível efetuar todas as quitações, por favor verifique!",
            'warning');
        }
      } else {
        Swal.fire("Erro",
          "Erro processando os dados!",
          'error');
      }
      lista_contasPagar();
    })
  }

  const listarPlanoContas = () => {
    let lista = [{ id: '', title: 'Nenhum' }]
    const url = rotas.planoContas
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista !== '') {
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i + 1] = { "id": ret.lista[i].plano_contas_id, "title": ret.lista[i].plano_contas }
          }
          setListaPlanoConta(lista)
        }
      })
      return (true)
    } catch (err) {
      console.log(err)
    }
  }


  const countSelectPagar = () => {
    let i = 0;

    for (let x = 0; x < listaContas.length; x++) {
      if (listaContas[x].pagar === 'S') {
        i++;
      }
    }
    return (i);
  }

  // if (loading == '2') {
  //   return (
  //     <Loading
  //       tipo='paginas'
  //     />
  //   )
  // } else {
  return (
    <div className="content">
      <Container fluid style={{ maxWidth: '95%', overflowX: 'hidden' }}>
        {/* <Row>
            <Col md="12" className="p-0"> */}
        <Card>
          <CardHeader>
            <Row>
              <Col>
                <CardTitle>Contas a pagar</CardTitle>
              </Col>
            </Row>
          </CardHeader>

          <CardBody>

            <Row className='d-flex align-items-center'>
              <Col md='4'>
                <FormGroup className=" ">
                  <ReactSelect
                    name="loja"
                    label="Lojas"
                    placeholder="Filtro por Loja"
                    options={listaLoja}
                    onChange={onChangeSelect('loja')}
                  ></ReactSelect>
                </FormGroup>
              </Col>

              <Col
                md={4}
              >
                <div className="mr-3 ">
                  <FormGroup>
                    <ReactSelect
                      required
                      name="planoConta"
                      label="Plano de Conta"
                      placeholder="Selecione plano de conta"
                      options={listaPlanoConta}
                      // defaultValue={form.planoContaSelect}
                      onChange={onChangeSelect('planoContaSelect')}
                    // onClick={form.planoContaSelect ? form.plano_contas_id = form.planoContaSelect.id : ''}                        
                    >
                    </ReactSelect>
                  </FormGroup>
                </div>
              </Col>

              <Col md='2'>
                <FormGroup className="mb-0 mt-2">
                  <DateTime
                    id="dataInicial"
                    name="dataInicial"
                    timeFormat={false}
                    closeOnSelect={true}
                    dateFormat="DD/MM/YYYY"
                    value={form.periodo.dataI}
                    onChange={(e) => changePeriodo(e, 'dataI')}
                    inputProps={{
                      className: "form-control",
                      placeholder: "Data Inicial"
                    }}
                  />
                </FormGroup>
              </Col>

              <Col md='2' className="d-flex justify-content-end">
                <FormGroup className="mb-0 mt-2 ">
                  <DateTime
                    id="dataFinal"
                    name="dataFinal"
                    timeFormat={false}
                    closeOnSelect={true}
                    dateFormat="DD/MM/YYYY"
                    value={form.periodo.dataF}
                    onChange={(e) => changePeriodo(e, 'dataF')}
                    inputProps={{
                      className: "form-control",
                      placeholder: "Data Final"
                    }}
                  />
                </FormGroup>

              </Col>

            </Row>

            <Row className='d-flex align-items-center'>

              <Col md="8">
                <div className="card-2 align-middle">
                  <FormGroup
                    className="mb-0"
                  >
                    {/* <Row className='d-flex align-items-center justify-content-around'> */}
                    <Row className='d-flex justify-content-around'>
                      <div className="form-check-radio  mb-0" >
                        <Label className="form-check-label">
                          <Input
                            type="radio"
                            name="status-notas"
                            id="nao-lancadas"
                            value="A"
                            // checked={checkStatus.status === 'P' ? true : false}
                            // onChange={onChange('controle')}
                            //disabled={checkControleEspecial}
                            // onChange={(e) => { changeFiltros(e) }}
                            //onClick={(e) => { changeFiltros(e) }}
                            checked={form.status == 'A' ? true : false}
                            onChange={onChange('status')}
                          />
                          Em aberto
                          <span className="form-check-sign"></span>
                        </Label>
                      </div>

                      <div className="form-check-radio mb-0" >
                        <Label className="form-check-label">
                          <Input
                            type="radio"
                            name="status-notas"
                            id="lancadas"
                            value="P"
                            // checked={checkStatus.status === 'L' ? true : false}
                            //onChange={onChange('controle')}
                            // onClick={changeStatus}
                            //disabled={checkControleEspecial}
                            // onClick={setselectStatus('L')}
                            // onChange={(e) => { changeFiltros(e) }}
                            //onClick={(e) => { changeFiltros(e) }}
                            checked={form.status == 'P' ? true : false}
                            onChange={onChange('status')}
                          />
                          Pago
                          <span className="form-check-sign"></span>
                        </Label>
                      </div>

                      <div className="form-check-radio mb-0" >
                        <Label className="form-check-label">
                          <Input
                            type="radio"
                            name="status-notas"
                            id="todas"
                            value="T"
                            // checked={checkStatus.status === 'T' ? true : false}
                            //onChange={onChange('controle')}
                            // onClick={changeStatus}
                            //disabled={checkControleEspecial}
                            // onClick={setselectStatus('T')}
                            // onChange={(e) => { changeFiltros(e) }}
                            //onClick={(e) => { changeFiltros(e) }}
                            checked={form.status == 'T' ? true : false}
                            onChange={onChange('status')}
                          />
                          Todas
                          <span className="form-check-sign"></span>
                        </Label>
                      </div>
                    </Row>
                  </FormGroup>
                </div>
              </Col>

              <Col md="4" className="d-flex justify-content-end">
                <Button
                  color="success"
                  className="align-self-center"
                  onClick={() => { lista_contasPagar() }}
                >Filtrar
                  <i className="nc-icon nc-zoom-split ml-2"
                    style={{ fontSize: '18px' }}
                  />
                </Button>
              </Col>
            </Row>


            {/* <Container> */}
            <Row className="d-flex align-items-center">
              <Col md="3" className="d-flex align-items-center">
                <Button
                  outline
                  className="w-100"
                  color="primary"
                  style={{ padding: '5px 20px' }}
                  onClick={() => abreModal('')}
                >
                  <i className="fas fa-plus" />
                  Cadastrar
                </Button>
              </Col>

              <Col
                className="d-flex align-items-center"
              >
                <Input
                  type="text"
                  placeholder="Buscar Contas a pagar..."
                  style={{ padding: '5px' }}
                  onChange={(e) => { lista_contasPagar(null, { page: 1, searchText: e.target.value }) }}
                />
                {loadingPesquisa &&
                  <Spinner
                    type="grow"
                    style={{ position: 'absolute', right: '20px', width: '20px', height: '20px', color: '#999999' }}
                  />
                }
              </Col>

              <Col md="3"
              // className="pl-0"
              >
                <Button
                  disabled={countSelectPagar() > 0 ? false : true}
                  className="mr-3 w-100"
                  color="info"
                  style={{ padding: '7px' }}
                  onClick={() => pagarEmMassa()}
                >
                  <i className="fa-solid fas fa-check" />
                  {listaContas.filter(item => item.pagar == 'S').length == 0
                    ? 'Pagar'
                    : 'Pagar R$ ' + listaContas.filter(item => item.pagar == 'S')
                      .map(item => { let valor = item.contpag_valor; return valor })
                      .map(item => { let valor = item.replace(/[^0-9,]/g, '').replace(',', '.'); return valor })
                      .reduce((acumulador, val) => Number(acumulador) + Number(val), 0)
                      .toFixed(2)
                      .replace('.', ',')}
                  {/* {countSelectPagar() > 0 ? 'Pagar [ ' + countSelectPagar() + ' ] Conta(s)' : 'Pagar'} */}
                </Button>
              </Col>


              {/* <Col md="2" className="pl-0">
                                <ClearSearchButton 
                                  // outline
                                  className = "m-0 w-100 rounded-0"
                                  color     = "primary"
                                  style     = {{ padding: '5px 10px' }}
                                  text = "Limpar"
                                  {...props.searchProps} 
                                />
                                <Button
                                  outline
                                  className = "m-0 w-100 rounded-0"
                                  color     = "primary"
                                  style     = {{ padding: '5px 20px' }}
                                  // onClick   = {limpaPesquisa}
                                  onClick={ () => this.clear(props) }
                                >
                                  <i className="fas fa-close"></i>
                                </Button>
                              </Col> */}
            </Row>
          </CardBody>
          {/* </Container> */}
          {/* <CardBody> */}

          {/* <Row> */}
          {loading && <Loading tipo='componente' />}
          {!loading && (
            <div style={{ padding: '0 16px 16px' }}>
              <DataTable
                columns={colunas}
                data={listaContas}
                readOnly={false}
                checkAll={false}
                recalculaMargemMkp={false}
                onChangeSwitch={changeSwitch}
                onlyChecked={false}
                setColumn={() => { }}
                gravaPosicaoColunas={() => { }}
                title="Tabela de Dados"
                onDoubleClick={abreModal}
                onSort={(field, order) => lista_contasPagar(null, { page: 1, searchText: '', sortField: field, sortOrder: order })}
              />
            </div>
          )}
          {/* </Row> */}

              
          <Row className="d-flex justify-content-center">
            <Pagination>
              <PaginationItem disabled={pageState == 1}>
                <PaginationLink
                  onClick={() => lista_contasPagar(null, { page: 1, searchText: "" })}
                  first
                />
              </PaginationItem>
              <PaginationItem disabled={pageState == 1}>
                <PaginationLink
                  onClick={() => lista_contasPagar(null, { page: pageState - 1, searchText: "" })}
                  previous
                />
              </PaginationItem>

              {controlPaginacao()}

              <PaginationItem disabled={pageState >= Math.ceil(countLista / 10)}>
                <PaginationLink
                  onClick={() => lista_contasPagar(null, { page: pageState + 1, searchText: "" })}
                  next
                />
              </PaginationItem>
              <PaginationItem disabled={pageState >= Math.ceil(countLista / 10)}>
                <PaginationLink
                  onClick={() => lista_contasPagar(null, { page: Math.ceil(countLista / 10), searchText: "" })}
                  last
                />
              </PaginationItem>
            </Pagination>
          </Row>



          <Modal
            size='xl'
            isOpen={modal}
          >
            <ModalHeader>CONTAS A PAGAR</ModalHeader>
            <ModalBody>
              <FormContas
                fechaModal={() => setModal(false)}
                conta_id={conta_id}
                setConta={setConta_id}
              >
              </FormContas>
            </ModalBody>
          </Modal>

          {/* </CardBody> */}
        </Card>
        {/* </Col>
            </Row> */}
      </Container>
    </div>
  )
  // }
}

export default ContasApagar;

